const animSpeed = 0.4;
class PlayerAnimations {
    constructor(xOffset, textures, size, visible = false) {
        let textureArray = [];
        textures.forEach(texture => {
            let tex = PIXI.Texture.from(texture);
            textureArray.push(tex);
        })
        this.animatedSprites = new PIXI.AnimatedSprite(textureArray);
        this.animatedSprites.loop = true;
        this.animatedSprites.animationSpeed = animSpeed;
        this.animatedSprites.visible = visible;
    
        this.animatedSprites.width = size;
        this.animatedSprites.height = size;
        this.animatedSprites.x = -size/4 + xOffset;
        this.animatedSprites.y = -size/4;
    }

    getSprites() {
        return this.animatedSprites;
    }

    play() {
        this.animatedSprites.play();
        this.animatedSprites.visible = true;
    }

    setAnimSpeed(speed) {
        this.animatedSprites.animationSpeed = speed * animSpeed;
    }

    stop() {
        this.animatedSprites.stop();
        this.animatedSprites.visible = false;
    }
}

export default PlayerAnimations;